import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import './hurme1.css';
import * as Sentry from '@sentry/browser';
import "./base/sitebase1.css"
import AppChat from './AppChat';
import AppChatArchives from './AppChatArchives';
import Login from './Login';
import Logout from './Logout';
// import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from "react-router-dom";
import { Route, Switch } from "react-router-dom";
import {Redirect} from 'react-router-dom';
import firebase from 'firebase'
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';


Sentry.init({dsn: "https://227a629ed34141c9b70770977992e5e6@sentry.io/1861269"});


ReactDOM.render(
    <BrowserRouter>
        <NotificationContainer />
        <Switch>
            {/* <Route exact path="/" component={App} /> */}
            {/* {(localStorage.getItem("user_roles") && localStorage.getItem("user_roles").indexOf('Support Executive') > -1) && <Redirect exact from='/' to='/chat'/>}
            {(localStorage.getItem("user_roles") && localStorage.getItem("user_roles").indexOf('Content Executive') > -1) && <Redirect exact from='/' to='/content/website'/>} */}
            {/* {(localStorage.getItem("user_roles") && localStorage.getItem("user_roles").indexOf('Support Executive') > -1) && <Route path="/chat" component={AppChat} />} */}
            <Redirect exact from='/' to='/chat'/>
            <Route path="/chat" component={AppChat} />
            <Route path="/chat-archives/:key" 
                    render ={
                        ()=>{
                            let urlNumber = window.location.pathname.split('/')[2]; 
                            let isExecutiveLink = false;
                            let userAccess = 'retail';
                            let country = 'india'
                            if(window.location.search){
                                const params = new URLSearchParams(window.location.search); 
                                isExecutiveLink = params.get('executive');
                                userAccess = params.get('user_access');
                                country = params.get('country');
                            }
                            return <AppChatArchives phoneno={urlNumber} isExecutiveLink={isExecutiveLink} userAccess={userAccess} country={country}/>
                        }
                    }
            />
            <Route path="/login" component={Login} />
            <Route path="/logout" component={Logout} />
            
        </Switch>
    </BrowserRouter>, 
    document.getElementById('page-body'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

// const express = require('express');
// const path = require('path');

// const app = express();

// // Serve the static files from the React app
// app.use(express.static(path.join(__dirname, 'client/build')));

// // An api endpoint that returns a short list of items
// // app.get('/api/getList', (req,res) => {
// //     var list = ["item1", "item2", "item3"];
// //     res.json(list);
// //     console.log('Sent list of items');
// // });

// // Handles any requests that don't match the ones above
// app.get('*', (req,res) =>{
//     res.sendFile(path.join(__dirname+'/client/build/index.html'));
// });

// const port = process.env.PORT || 5000;
// app.listen(port);

// console.log('App is listening on port ' + port);